module.exports = __webpack_public_path__ + "img/content-logo-hidden.8cd2d13a.png";